module.exports = __webpack_public_path__ + "img/ejemplo_lubricador.8e3885eb.jpg";